import { Button } from "antd";
import { FacebookFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export default function ConnectInstagramView() {
    const { t } = useTranslation();
    return (
        <div className="md:pl-6 flex flex-col h-full">
            <div className="flex justify-between items-center mb-4">
                <div className="text-base font-medium">
                    {t('chats.add_instagram')}
                </div>
            </div>
            <div className="flex flex-col items-center justify-center text-center py-12">
                {/* ICONS */}
                <div className="flex items-center gap-6 mb-6">

                    {/* Buso Icon */}
                    <div className="w-[48px] h-[48px] bg-white rounded-full shadow-md flex items-center justify-center">
                        <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-xl">
                            <img src="https://khothi.buso.asia/uploads/2025/10/photo_library/i0sGPLyOtv3a2fb45cb6264d9f6848b54d45c8a57f.png" alt="Buso" className="w-full h-full object-contain" />
                        </div>
                    </div>

                    {/* Arrow */}
                    <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#3e91ab" viewBox="0 0 256 256"><path d="M24,128A72.08,72.08,0,0,1,96,56H204.69L194.34,45.66a8,8,0,0,1,11.32-11.32l24,24a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32-11.32L204.69,72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H51.31l10.35-10.34a8,8,0,0,0-11.32-11.32l-24,24a8,8,0,0,0,0,11.32l24,24a8,8,0,0,0,11.32-11.32L51.31,200H160a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"></path></svg></div>

                    {/* Instagram Icon */}
                    <div className="w-[48px] h-[48px] !rounded-full flex items-center justify-center text-white text-3xl shadow-md overflow-hidden">
                        <img src="https://pancake.vn/static/images/platform-connection/instagram.png" alt="Buso" className="w-full h-full object-contain" />
                    </div>
                </div>

                {/* TITLE */}
                <h2 className="text-xl font-semibold text-gray-800 mb-3">
                    {t('chats.connect_buso_instagram')}
                </h2>

                {/* DESCRIPTION */}
                <p className="text-gray-500 max-w-[340px] text-sm mb-8 leading-relaxed">
                    {t('chats.instagram_desc')}
                </p>

                {/* BUTTON */}
                <Button
                    size="large"
                    className="
                        w-[340px]
                        h-[42px]
                        flex items-center justify-center gap-2
                        border border-gray-300
                        hover:!border-[#3e91ab]
                        mb-4
                        hover:!border-[#3e91ab]
                        bg-[#3e91ab]
                        hover:!bg-[#357f96]
                        hover:border-[#357f96]
                        text-white
                        hover:!text-white
                    "
                >
                    <div className="w-[20px] h-[20px]">
                        <img className="platform-icon-img instagram rounded-[4px]" src="https://pancake.vn/static/images/platform-connection/instagram.png" alt="instagram" />
                    </div>
                    <span className="font-medium">
                        Unified Onboarding
                    </span>
                </Button>

                <Button
                    size="large"
                    className="
                        w-[340px]
                        h-[42px]
                        flex items-center justify-center gap-2
                        border border-gray-300
                        hover:!border-[#3e91ab]
                    "
                >
                    <div className="w-[20px] h-[20px]">
                        <img className="platform-icon-img facebook rounded-[4px]" src="https://pancake.vn/static/images/platform-connection/facebook.png" alt="facebook" />
                    </div>
                    <span className="font-medium">
                        {t('chats.login_facebook')}
                    </span>
                </Button>

                {/* GUIDE LINK */}
                <div className="mt-4 text-sm text-[#357f96] cursor-pointer hover:underline">
                    {t('chats.guide')}
                </div>
            </div>
        </div>
    );
}